<template>
  <div class="product-spec-container">
    <div class="product-spec">
      <div class="title" v-if="productSpecList.length > 0">
        Select your desired item color(s)
      </div>
      <div :class="[
        'product-spec__form',
        'error-block',
        specErrorMsg ? 'is-error' : ''
      ]">
        <table class="product-spec__groups">
          <tbody :class="[
            'product-spec-group',
            group.displayType === 'dropdown' ? 'is-row' : ''
          ]" v-for="(group, groupIndex) in productSpecList" :key="group.name">
            <tr v-if="isMultiGroup && group.displayType !== 'dropdown'">
              <th colspan="2">{{ group.name }}</th>
            </tr>
            <tr v-if="
              group.displayType == 'image' || group.displayType === 'button'
            " @mouseleave="handleMouseLeave">
              <td colspan="2">
                <ProductSpecGroupItem v-for="(color, index) in getGroupValues(group)" :color="color"
                  :displayType="group.displayType" :group-index="groupIndex" :key="index" :taken="color.selected"
                  :selected="isSelected(groupIndex, group, color)" :class="group.values.length === 1 ? 'is-one' : ''"
                  @click="onColorClick(groupIndex, group, color)" @hover="onColorMouseEnter">
                </ProductSpecGroupItem>
                <ap-button type="default" class="view-more-colors" v-if="
                  isViewMoreVisible &&
                  group.displayType === 'button' &&
                  group.values.length > 10
                " text @click="isViewMoreVisible = false">More colors...</ap-button>
              </td>
            </tr>
            <tr class="product-spec-group" v-else-if="group.values.length === 1">
              <th>{{ group.name }}</th>
              <td>
                <ProductSpecGroupItem v-for="(color, index) in group.values" :color="color"
                  :displayType="group.displayType" :group-index="groupIndex" :key="index" :taken="color.selected"
                  :selected="isSelected(groupIndex, group, color)" class="is-one">
                </ProductSpecGroupItem>
              </td>
            </tr>
            <tr v-else class="product-spec-group__select">
              <th>{{ group.name }}</th>
              <td>
                <productSpecSelect v-model="selectedValues[groupIndex].value" :values="group.values.filter(
                  (f) => f.value !== '-1'
                )" @change="(val: ProductSpecItem) => onSelect(group, val)"></productSpecSelect>
              </td>
            </tr>
          </tbody>
          <tbody v-if="selectedList.length > 0">
            <tr>
              <th class="qty-title">Quantity</th>
              <td class="no-more-spec" v-if="selectedList.length > 0">
                <span>{{ selectedList[0].getQty() }}</span>
              </td>
            </tr>
            <tr v-if="Array.isArray(selectedList[0].quantity)">
              <th class="qty-title">Size</th>
              <td class="no-more-spec">
                <select v-model="selectedList[0].specSampleSizeType">
                  <option v-for="(item) in selectedList[0].quantity" :key="item.size" :value="item.size">{{ item.size }}
                  </option>
                </select>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="product-spec-btns" v-show="selectedList.length > 0">
        <ap-button type="primary" size="small" @click="onContinueClick">Continue</ap-button>
      </div>
    </div>
  </div>
</template>
<script setup lang="ts">
import { computed, inject, reactive, ref } from 'vue'
import { buildSpecImg } from '../../model'
import { useProductSpec } from '../../store/modules/productSpec'
import ProductSpecGroupItem from './productSpecGroupItem.vue'
import productSpecSelect from './productSpecSelect.vue'
import { SHOW_BIG_IMAGE_KEY, SHOW_PRICE_GROUP_KEY } from '../../token'
import '../../style/product-spec.less'
import {
  type ProductSpec,
  type ProductSpecItem,
  type SelectedProductSpecItem
} from '../../types'
import { ApButton } from '@anypromo/components-pc'

const props = withDefaults(
  defineProps<{
    isFreeGiftCustomize: boolean
    productSpecList: ProductSpec[]
  }>(),
  {
    isFreeGiftCustomize: false,
    productSpecList: () => []
  }
)

const emit = defineEmits({
  'go-next': () => true
})
const { productSpecList } = reactive(props)
// 是否有错误
const specErrorMsg = ref('')
const productSpecListState = useProductSpec()

const isMultiGroup = productSpecList.length > 1
const isViewMoreVisible = ref(true)
const selectedList = productSpecListState.getSelectedList

const getGroupValues = (spec: ProductSpec) => {
  if (spec.displayType !== 'button' || isViewMoreVisible.value === false)
    return spec.values

  return spec.values.filter((item, index) => index < 10)
}

/**
 * 临时选中的值
 */
const selectedValues = computed<(SelectedProductSpecItem)[]>(() => {
  return productSpecList.map((f) => {
    if (selectedList.length === 1) {
      const spec = selectedList[0].productSpec.find(
        (sp) => sp.name === f.name
      )

      if (spec) {
        return {
          name: f.name,
          value: spec.value
        }
      }
    }
    return {
      name: f.name,
      value: f.values.length === 1 ? f.values[0] : undefined
    }
  })
}
)

const showBigImage = inject(SHOW_BIG_IMAGE_KEY)
if (!showBigImage) {
  console.warn('build error')
}

const showPriceGroup = inject(SHOW_PRICE_GROUP_KEY)
if (!showPriceGroup) {
  console.warn('build error')
}
const handleMouseLeave = (evt: MouseEvent) => {
  // window.$('#zoomBigImage').remove()

  if (showBigImage) {
    showBigImage.hide()
  }
}
const onColorMouseEnter = (
  groupdIndex: number,
  color: ProductSpecItem,
  target: HTMLElement
) => {
  // 先获取选中次数

  var str = ''
  if (productSpecList.length <= 1) {
    str = `<label>${productSpecList[0].name}:&nbsp;</label>${color.text}`
    if (color.outOfStock) {
      str +=
        '<div class="out-of-stock"><span class="tips">Out of Stock</span></div>'
    }
  } else {
    str = selectedValues.value
      .map(function (item, idx) {
        var spec = {
          name: item.name,
          selectedText: item.value?.text
        }
        if (groupdIndex === idx) {
          spec.selectedText = color.text
        }
        return (
          '<div><label>' +
          spec.name +
          ':&nbsp;</label>' +
          spec.selectedText +
          '</div>'
        )
      })
      .join('')
    if (color.outOfStock) {
      str +=
        '<div class="out-of-stock"><span class="tips">Out of Stock</span></div>'
    }
  }
  const imgUrl = buildSpecImg({
    list: selectedValues.value.map((f) => f.value),
    index: groupdIndex,
    color,
    size: 'big'
  })
  if (imgUrl !== undefined) {
    if (showBigImage) {
      showBigImage.show(imgUrl, str, target)
    }
  }
}

const isSelected = (
  groupIndex: number,
  group: ProductSpec,
  color: ProductSpecItem
) => {
  // 如果支持assorted
  if (isMultiGroup) {
    // 只有一组颜色
    return selectedList.some(
      (f) =>
        f.productSpec.find((sp) => sp.name === group.name)?.value.value ===
        color.value
    )
  } else if (productSpecList.length === 1) {
    // 只有一组颜色
    return selectedList.some(
      (f) => f.productSpec[0].value.value === color.value
    )
  }
  return false
}

const onColorClick = (
  groupIndex: number,
  group: ProductSpec,
  color: ProductSpecItem
) => {
  if (group.displayType === 'image' || group.displayType === 'button') {
    if (isSelected(groupIndex, group, color)) {
      // 如果支持多group，或者支持assorted，那就允许取消
      return
    }
  }

  if (beforeCheckColor(group.name, color) === false) {
    return
  }
  if (productSpecListState.getSelectedList.length > 0) {
    // 需要更新图片了
    productSpecListState.getSelectedList[0].setValue(group.name, color)
  }
}
const beforeCheckColor = (name: string, color: ProductSpecItem) => {
  if (color.enabled === false) {
    // 需要弹出提示
    //  options: ShowPopupPriceGroupProvideOption
    // ShowPopupPriceGroupProvideOption
    showPriceGroup!({
      type: 'productSpec',
      value: {
        name: name,
        value: color.value,
        text: color.text
      }
    }).then((data) => {
      console.log('showPriceGroup')
    })
    return false
  }

  return true
}

const onSelect = (group: ProductSpec, val: ProductSpecItem) => {
  if (selectedList.length > 0) {
    selectedList[0].setValue(group.name, val)
  }
}
const onContinueClick = () => {
  // 检查qty
  if (Array.isArray(selectedList[0].quantity)) {
    const qty = selectedList[0].getQty();

    selectedList[0].quantity.forEach(item => {
      if (item.size === selectedList[0].specSampleSizeType) {
        item.quantity = qty;
      } else {
        item.quantity = ''
      }
    })
  }

  emit('go-next')
}
</script>

<style lang="less">
.qty-title {
  font-weight: 500;
  font-size: 13px;
  vertical-align: top;
  padding: 14px 15px 14px 0;
  width: 55px;
}
</style>
